import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import API from "../api/axiosInstance";

interface RowActionsMenuProps {
  rowId: string;
  rowData: any;
  tableId: string;
  handleActionSelect: (action: string, data: any) => void;
}

const RowActionsMenu: React.FC<RowActionsMenuProps> = ({
  rowId,
  rowData,
  tableId,
  handleActionSelect
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleAction = async (action: string) => {
    handleClose();

    if (!handleActionSelect) return;
    handleActionSelect(action, rowData);

//    if (action === "delete") {
//      if (window.confirm("Are you sure you want to delete this record?")) {
//        await API.delete(`/tables/${tableId}/rows/${rowId}`);
//        handleActionSelect("deleted", rowData);
//      }
//    } else if (action === "clone") {
//      const response = await API.post(`/tables/${tableId}/rows/${rowId}/clone`);
//      handleActionSelect("cloned", response.data);
//    } else {
//      handleActionSelect(action, rowData);
//    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <IconButton size="small" onClick={handleOpen}>
        <SettingsIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem onClick={() => handleAction("view")}>View</MenuItem>
        <MenuItem onClick={() => handleAction("edit")}>Edit</MenuItem>
        <MenuItem onClick={() => handleAction("clone")}>Clone</MenuItem>
        <MenuItem onClick={() => handleAction("delete")}>Delete</MenuItem>
        <MenuItem onClick={() => handleAction("history")}>History</MenuItem>
      </Menu>
    </div>
  );
};

export default RowActionsMenu;
